module.exports = __webpack_public_path__ + "img/IRCenter-rouned-logo-no-padding.svg";